export default __webpack_public_path__ + "static/media/Book_10.864b3631.xlsx";